import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	fragment offersFilters_QueryFragment on Query {
		...selectAcademiesTagField_QueryFragment
	}
`;
